import React from 'react';

function AlertCircle(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12 2C6.47732 2 2 6.47732 2 12C2 17.5227 6.47732 22 12 22C17.5227 22 22 17.5227 22 12C22 6.47732 17.5227 2 12 2ZM12 3.25C16.8323 3.25 20.75 7.16768 20.75 12C20.75 16.8323 16.8323 20.75 12 20.75C7.16768 20.75 3.25 16.8323 3.25 12C3.25 7.16768 7.16768 3.25 12 3.25ZM12 5.75C12.3138 5.75 12.5736 5.98126 12.6182 6.28264L12.625 6.375V13.25C12.625 13.5952 12.3452 13.875 12 13.875C11.6862 13.875 11.4264 13.6437 11.3818 13.3424L11.375 13.25V6.375C11.375 6.02982 11.6548 5.75 12 5.75ZM12 15.125L12.1093 15.1313C12.5755 15.1855 12.9375 15.5818 12.9375 16.0625C12.9375 16.5802 12.5177 17 12 17C11.4823 17 11.0625 16.5802 11.0625 16.0625C11.0625 15.5818 11.4245 15.1855 11.8907 15.1313L12 15.125Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default AlertCircle;
